'use client'

import { Bookmark } from 'lucide-react'
import ToggleIconButton from './ToggleIconButton'

interface ThreadBookmarkButtonProps {
  isBookmarked: boolean
  onToggle: () => Promise<void> | void
  className?: string
  disabled?: boolean
}

export default function ThreadBookmarkButton({
  isBookmarked,
  onToggle,
  className,
  disabled = false,
}: ThreadBookmarkButtonProps) {
  return (
    <ToggleIconButton
      isActive={isBookmarked}
      onToggle={onToggle}
      icon={Bookmark}
      activeColor="fill-blue-600 text-blue-600"
      inactiveColor="text-gray-400 hover:text-blue-600"
      rippleColor="bg-blue-600/20"
      className={className}
      disabled={disabled}
    />
  )
}
